// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__C-AHw","logo":"SignUp_logo__-21dS"};